module.exports = __webpack_public_path__ + "static/media/for-apple-devices.9944ba4b.png";